export default class ScrollbarEvent extends CustomEvent<null> {
  percent: number;

  constructor(type: 'start' | 'move' | 'end' | 'refresh', percent: number) {
    super(`scrollbar${type}`, { bubbles: true, detail: null });

    this.percent = percent;
  }
}
